import * as React from 'react'

const SvgRequestQuoteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 13.75v3.75h-10v-15H10V1.25H3.75c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3.75h-1.25zM18.462 3.6L16.4 1.537a1 1 0 00-1.4 0l-8.75 8.75v3.463h3.456L18.456 5a1 1 0 000-1.4h.006zm-9.274 8.9H7.5v-1.688l5.9-5.906L15.094 6.6l-5.906 5.9zm6.787-6.781l-1.694-1.694L15.7 2.606 17.394 4.3l-1.419 1.419z"
      fill="#163250"
    />
  </svg>
)

export default SvgRequestQuoteIcon
